import { Link } from '@rocketlane/rocket-router';
import { Space } from 'antd';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  Title,
  Description,
  LinkText,
  UserInfo,
} from 'components/atoms/form-elements';
import { RoutePaths } from 'constant';
import { ReactComponent as PaperplaneSVG } from 'routes/forgot-password/paper-plane.svg';

interface Props {
  email: string | undefined;
}

const PageTitle = styled(Title)`
  color: var(--black-100);
`;

const StyledSpace = styled(Space)`
  padding: 120px;
`;

export const SuccessPage: FC<React.PropsWithChildren<Props>> = ({ email }) => {
  return (
    <StyledSpace direction="vertical" size={16}>
      <PaperplaneSVG />
      <PageTitle>
        <FormattedMessage id="forgot_password.success" />
        <strong>{email}</strong>
        <br />
        <FormattedMessage id="forgot_password.success_msg" />
      </PageTitle>
      <Description>
        <FormattedMessage id="forgot_password.success_help" />
      </Description>

      <UserInfo>
        <FormattedMessage
          id="forgot_password.cta_back"
          values={{
            a: (chunks) => (
              <Link to={RoutePaths.login}>
                <LinkText>{chunks}</LinkText>
              </Link>
            ),
          }}
        />
      </UserInfo>
    </StyledSpace>
  );
};
